import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.about'), href: '/sobre' },
    { label: t('footer.editorial'), href: '/editorial-policy' },
    { label: t('footer.contact'), href: '/contato' },
    { label: t('footer.privacy'), href: '/privacy' },
    { label: t('footer.terms'), href: '/terms' },
    { label: t('footer.disclaimer'), href: '/disclaimer' },
  ];

  return (
    <footer className="w-full bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <span className="text-xl font-bold text-foreground-950 tracking-tight">
                CSSBuy<span className="text-primary-500">BR</span>.INK
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer.disclaimerText')}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">Links</h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Main Website CTA */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-foreground-950 mb-4 uppercase tracking-wider">Main Website</h4>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <span>{t('button.cssbuySpreadsheet')}</span>
              <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-5 py-3 text-sm font-semibold border-2 border-primary-500 text-primary-500 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              <span>{t('button.buyItNow')}</span>
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-200/60 mt-10 pt-6">
          <p className="text-sm text-foreground-500 text-center">
            {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
}